import { useNavigate, useParams } from "react-router-dom";
// import Navbar from "../../components/navbar/Navbar";
// import Footer from "../../components/footer/Footer";
// import Header from "../../components/header/Header";
import { IoHeart } from "react-icons/io5";
import { IoIosHeartEmpty } from "react-icons/io";
import {
  calculateDiscountedPrice,
  renderStars,
} from "../../utils/functions.tsx";
import { useCallback, useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import styles from "./companyCampProductList.module.css";
import { BiChevronsRight } from "react-icons/bi";
import { getFetcher, postFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { useUser } from "../../context/UserContext.tsx";
import { FaChevronDown } from "react-icons/fa";
import { useCurrency } from "../../context/CurrencyContext.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";

interface IProduct {
  id: string | number;
  name: string;
  brand: string;
  price: number;
  description: string;
  attributes: any;
  bulkDiscounts: null | boolean;
  images: any;
  supplierId: string;
  dealersId: string[];
  categoryId: number;
  subCategoryId: number;
  stock: number;
  rating: number;
  discount: number;
  isFeatured: boolean;
  isFlash: boolean;
  coupon: number;
  status: boolean;
  createdAt: string;
  updatedAt: string;
}

interface ISupplier {
  city: string;
  companyName: string,
  companyTypeId: number;
  createdAt: string,
  district: string,
  email: string,
  fullName: string,
  coverImg: string,
  id: string,
  identityNumber: string,
  invoiceType: string,
  kepAddress: string,
  marketPlaceName: string,
  mersisNumber: string,
  openAddress: string,
  phoneNumber: string,
  status: boolean,
  supplierProductTypeId: number,
  taxNumber: string,
  taxOffice: string,
  updatedAt: string,
}

const CompanyCampProductList = () => {
  const { t } = useLanguage();
  const { exchangeRate } = useCurrency();
  const [products, setProducts] = useState<IProduct[]>([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [favoriteProductIds, setFavoriteProducts] = useState<Set<string>>(
    new Set<string>()
  );
  const { user, addFavoriteProduct, removeFavoriteProduct } = useUser();
  const [supplier, setSupplier] = useState<ISupplier>();

  const { id } = useParams();
  const navigate = useNavigate();

  // LIKE PRODUCT TOGGLE
  const toggleLike = useCallback(
    async (id: any, productName: string) => {
      if (!user) {
        toast.error(t('toastMessage', 'campErr'));
        return;
      }
      const isLiked = favoriteProductIds.has(id);

      try {
        if (isLiked) {
          await removeFavoriteProduct(id);
          setFavoriteProducts((prevIds) => {
            const newIds = new Set(prevIds);
            newIds.delete(id);
            return newIds;
          });
          toast.info(`${productName} ${t('toastMessage', 'addBasketFavInfo')}`);
        } else {
          await addFavoriteProduct(id);
          setFavoriteProducts((prevIds) => {
            const newIds = new Set(prevIds);
            newIds.add(id);
            return newIds;
          });
          toast.success(`${productName} ${t('toastMessage', 'addBasketFavSuc')}`);
        }
      } catch (error) {
        toast.error("Error");
      }
    },
    [favoriteProductIds, addFavoriteProduct, removeFavoriteProduct]
  );

  // FETCH PRODUCT BY SUPPLIER ID
  useEffect(() => {
    if (!id) return;



    ;
  }, [id, user]);

  const getProductsBySupplierId = async () => {
    try {
      const [productsResponse, favoritesResponse] = await Promise.all([
        postFetcher(
          endpoints.products.getProductBySupplierId, {
          arg: {
            supplierId: id,
            pageNumber: pageNumber,
          }
        }
        ),
        user
          ? getFetcher(`${endpoints.user.getFavorites}/${user.id}`)
          : Promise.resolve(null),
      ]);

      if (productsResponse.result) {
        setProducts((prevProducts: any) => [...prevProducts, ...productsResponse.products]);
      } else {
      }

      if (favoritesResponse?.result) {
        const favoriteIds = new Set<string>(
          favoritesResponse.favoriteProducts.map(
            (favoriteProduct: any) => favoriteProduct.productId
          )
        );
        setFavoriteProducts(favoriteIds);
      }
    } catch (error) {
      console.error("Reklam ürünleri getirilirken hata oluştu:", error);
    }
  };

  useEffect(() => {
    setProducts([]);
    setPageNumber(0);
    getProductsBySupplierId();
  }, [id]);


  useEffect(() => {
    if (pageNumber > 0) {
      getProductsBySupplierId();
    }
  }, [pageNumber]);
  // FETCH SUPPLIER BY SUPPLIER ID
  useEffect(() => {
    const fetchSupplier = async () => {
      try {
        const response = await getFetcher(
          endpoints.supplier.getSupplierById.replace("{id}", id || "")
        );
        if (response.result) {
          setSupplier(response.supplier);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSupplier();
  }, []);

  const handleClickMore = () => {
    setPageNumber(prevPageNumber => prevPageNumber + 1);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* <Header />
      <Navbar /> */}
      <main className="flex-grow mb-20 overflow-y-auto">
        <div className="  ">
          {/* HEADER */}
          {
            supplier?.coverImg && (
              <div className="flex justify-center items-center w-9/12 mx-auto rounded-xl shadow-xl my-2 ">
                <img
                  src={supplier?.coverImg}
                  alt="weeklyCampaign"
                  className="w-full h-auto object-center rounded-xl"
                  style={{ maxHeight: "30rem" }}
                />
              </div>
            )
          }

          <div className="flex justify-center items-center my-10 font-semibold text-primary-color text-3xl p-4 text-center">
            {supplier?.marketPlaceName} Mağazasındaki Ürünler
          </div>

          {/* PRODUCTS */}
          <section
            className={`flex-grow self-center ${styles.scrollableSection}`}
          >
            <div className="flex flex-wrap items-center justify-center gap-2">
              {products.map((product: IProduct | any) => {
                const parsedImage = (product.images);
                return (
                  <div key={product.id} className="w-72 lg:w-96 h-full p-1">
                    <div>
                      <div className="h-full flex flex-col justify-between overflow-hidden">
                        <div className="w-full flex justify-center rounded-lg relative py-6 bg-color-product-bg">
                          <img
                            src={parsedImage[0]}
                            alt={product.name}
                            className="h-64 object-cover rounded-t-lg cursor-pointer"
                            onClick={() =>
                              navigate(`/product-detail/${product.id}`)
                            }
                          />
                          <button
                            className="absolute top-2 right-2 rounded-full bg-transparent"
                            onClick={() => toggleLike(product.id, product.name)}
                          >
                            {favoriteProductIds.has(product.id) ? (
                              <IoHeart className="text-yellow-300 text-3xl mt-2 mr-2" />
                            ) : (
                              <IoIosHeartEmpty className="text-yellow-300 text-3xl mt-2 mr-2" />
                            )}
                          </button>
                        </div>
                        <div className="p-4 flex flex-col justify-between flex-grow">
                          <h2 className="text-lg font-bold truncate">
                            {product.name}
                          </h2>
                          <div className="flex items-center mt-2">
                            <div className="flex items-center">
                              {renderStars(product.rating)}
                            </div>
                          </div>
                          <div className="w-full mt-4 flex justify-between items-end">
                            <div className="flex gap-2">
                              {product.discount > 0 ? (
                                <>
                                  <p className="text-lg lg:text-2xl font-semibold">
                                    ₺
                                    {calculateDiscountedPrice(
                                      product.price,
                                      product.discount,
                                      0,
                                      exchangeRate
                                    )}
                                  </p>
                                  <p className="text-sm lg:text-xl font-semibold line-through text-gray-500">
                                    ₺{product.price}
                                  </p>
                                </>
                              ) : (
                                <p className="text-lg lg:text-2xl font-semibold">
                                  ₺{product.price}
                                </p>
                              )}
                              <div className="w-8 h-5  flex items-center justify-center text-sm bg-red-200 text-red-700 px-4 rounded-3xl">
                                {product.discount}%
                              </div>
                            </div>
                            <button
                              className={`text-white min-w-8 md:min-w-10 z-10 text-lg md:text-2xl font-bold p-2 rounded-full shadow-md bg-primary-color `}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/product-detail/${product.id}`);
                              }}
                            >
                              <BiChevronsRight />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>


          <div className='flex justify-center items-center w-full mt-6 text-white'>
            <button onClick={handleClickMore} className='bg-primary-color w-36 font-bold rounded flex justify-center gap-x-2 items-center active:scale-95 transform transition-all'>Daha Fazla <FaChevronDown className='font-bold text-white' size={14} /></button>
          </div>
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default CompanyCampProductList;
